import { render } from "./UndergroundNpc1.vue?vue&type=template&id=8a70ea32&scoped=true"
import script from "./UndergroundNpc1.vue?vue&type=script&lang=js"
export * from "./UndergroundNpc1.vue?vue&type=script&lang=js"

import "./UndergroundNpc1.vue?vue&type=style&index=0&id=8a70ea32&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a70ea32"]])

export default __exports__